export default "__VITE_ASSET__BDTdfRX6__"